<script lang="ts">
	//Svelte hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';
	//Helpers
	import {
		get_mode,
		is_dali,
		is_gen_2,
		is_gen_z,
		isBluTRV,
		isGen2EM,
		isEMWithoutSwitch,
		isWallDisplay,
		real_id,
		is_loqed,
		isDiffuser,
		isPill,
		isCameraDevice,
		isActuator as isActuatorHelper,
		isXMODDevice,
		isNoRelayPlug,
		isFanDevice,
	} from 'src/helpers/interface_helpers';
	import { hasSysChComponents } from 'src/helpers/xmod_helpers/xcspec_helpers';
	import { format } from 'svelte-i18n';
	import { dndHandleClick } from 'src/components/Lists/list-helpers';
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { isPeripheralDevice } from 'src/helpers/addons/addon_device_helpers';
	import { checkDeviceForceUpdate } from 'src/helpers/firmware_helpers';
	import { isIRControllerCategory } from 'src/helpers/ir_controller_helpers';

	//Configs
	import { devices_config } from '@devices/index';
	//Stores
	import { edit, update } from 'src/stores/ui/edit_lists';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { updating_devices } from 'src/stores/device-runtime/process';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Components
	import ControlOnOff from 'src/components/Controls/Single/ControlOnOff.svelte';
	import ControlDirection from 'src/components/Controls/Single/ControlDirection.svelte';
	import ControlTrv from 'src/components/Controls/Single/ControlTrv.svelte';
	import InputsReaderVisualizer from 'src/components/Controls/Indicators/InputsReaderVisualizer.svelte';
	import ControlOnOffAddon from 'src/components/Controls/Single/ControlOnOffAddon.svelte';
	import ControlDirectionG2 from 'src/components/Controls/Single/ControlDirectionG2.svelte';
	import ControlOnOffZ from 'src/components/Controls/Single/ControlOnOffZ.svelte';
	import ControlLock from 'src/components/Controls/Single/ControlLock.svelte';
	import ControlDirectionZ from 'src/components/Controls/Single/ControlDirectionZ.svelte';
	import TemplatesControl from 'src/components/XT1/TemplatesControl.svelte';
	import BluTrvControl from 'src/components/DevicesSettings/VirtualComponents/BluTRV/BluTrvControl.svelte';
	import AuthenticateDevice from 'src/components/Devices/DeviceWizard/AuthenticateDevice.svelte';
	import ControlWallDisplayThermostat from 'src/components/Controls/Single/ControlWallDisplayThermostat.svelte';
	import ControlMedia from 'src/components/Controls/Single/ControlMedia.svelte';
	import RadarControl from 'src/components/Controls/Single/RadarControl.svelte';
	import ControlOnOffDiffuser from 'src/components/Controls/Single/ControlOnOffDiffuser.svelte';
	import ControlVentoraBoost from 'src/components/Controls/Single/ControlVentoraBoost.svelte';
	import PillControlStatusSlot from 'src/components/ThePill/PillControlStatusSlot.svelte';
	import VirtualDeviceControl from 'src/components/DevicesSettings/VirtualComponents/VirtualDeviceControl.svelte';
	//Design system components
	import {
		ActionsContainer,
		Checkbox,
		IconButton,
		Label,
		LabelV2,
		Loader,
		Icon,
		CircularProgress,
		type LabelV2PropsTypes,
		type DoubleDeviceButtonV2PropsTypes,
		type DeviceButtonV2PropsTypes,
		type TripleDeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	import { devices_config_wave } from 'src/devices_config_wave';
	import type { FormattedItemType } from 'src/components/DevicesSettings/CustomizeDeviceWizard/customize-device-wizard-helpers';
	import { checkIsCriticalEvent } from 'src/helpers/device_data_helpers';
	import ControlCamera from 'src/components/Controls/Single/ControlCamera.svelte';
	import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
	import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
	import { isProSensorAddon } from 'src/helpers/addons/addon_support_helpers';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';
	import { ComponentSize } from '@Shelly/shelly-design-system/helpers/enums';

	export let device, status, settings, statuses;
	export let type = '';
	export let isLoading = false;
	export let notAuthenticated = false; //this is for wall display authentication
	export let isCondensed = false;
	export let inPreivew = false;
	export let disableSelection = false;
	export let useV2Components = false;
	export let labelV2Props: Partial<LabelV2PropsTypes> = {};
	export let devBtnsV2Props: {
		deviceButtonV2?: Partial<DeviceButtonV2PropsTypes>;
		doubleDeviceButtonV2?: Partial<DoubleDeviceButtonV2PropsTypes>;
		tripleDeviceButtonV2?: Partial<TripleDeviceButtonV2PropsTypes>;
	} = {};
	// extract main status

	let mainParamElement = null;
	const dispatch = createEventDispatcher();
	$: deviceState = getDeviceState(device?.channel >= 100 ? device?.id : real_id(device?.id)) as any;
	$: isLoading = $deviceState?.isLoading;
	$: icon = $deviceState?.icon;
	$: iconColor = $deviceState?.iconColor;
	$: isUpdating = $deviceState?.type === 3;
	$: fwUpdateProgress =
		$updating_devices?.[device?.id]?.prog === undefined
			? 101
			: $updating_devices?.[device?.id]?.prog;

	let isActuator = false;
	let authenticate = false;
	$: isGenZ = is_gen_z(device);
	$: isLoqed = is_loqed(device);

	let main_label: { icon: string; value: string; iconColor: string } = {
		icon: '',
		value: '',
		iconColor: '',
	};
	let mode: string = '';

	const isGen2 = is_gen_2(device);
	const isDali = is_dali(device);
	let daliErrors;
	let noControlGearDevices = false;
	const isInputsReader =
		device?.category === 'inputs_reader' ||
		(device?.category === 'module' && device?.mode === 'inputs_reader') ||
		device?.category === 'remote_control';

	beforeUpdate(() => {
		if (
			status?.online &&
			(device.category == 'virtual_device' ||
				'undefined' !== typeof devices_config[device.type] ||
				'undefined' !== typeof devices_config_wave[device.type]) &&
			'undefined' !== typeof device
		) {
			const main_label_filter = statuses.find((label) => {
				return 'undefined' !== typeof label.main;
			});

			main_label = 'undefined' !== typeof main_label_filter ? main_label_filter : main_label;

			mode = get_mode(device, status, settings);
			isActuator = isActuatorHelper(settings, device);

			if (device?.mainActionType === 'param' && !inPreivew) {
				let array: FormattedItemType[] = Object.values(device?.statusLabelParam);
				let mainElement = array.find((el) => el?.m === true);
				let index = statuses.findIndex((el) => el.name === mainElement?.n);

				// Bulbs expose 'color' in color mode and 'color_temp' in white mode.
				// Treat them as the same "current color" parameter for the big slot,
				// so the saved selection keeps rendering after a mode switch.
				if (index < 0 && (mainElement?.n === 'color' || mainElement?.n === 'color_temp')) {
					index = statuses.findIndex((el) => el.name === 'color' || el.name === 'color_temp');
				}

				if (index >= 0) {
					mainParamElement = statuses[index];
				} else {
					mainParamElement = mainElement;
				}
			}
			noControlGearDevices = isDali ? status?.dali?.cg_count === 0 : false;
			daliErrors = isDali ? status?.dali?.errors?.length > 0 : undefined;
		}
	});

	const onHandleFilterSelect = (e: MouseEvent | TouchEvent) => {
		e.stopPropagation();
		dispatch('device-select', e);
	};

	const onHandleDeviceUpdate = (e: MouseEvent | TouchEvent) => {
		e.stopPropagation();
		dispatch('device-update', e);
	};

	$: hasComponents = hasSysChComponents(status);
	$: labelSizeCondition = isCondensed
		? ComponentSize.S
		: type === 'widget'
			? ComponentSize.XL
			: ComponentSize.L;
</script>

{#if $edit && $update.value}
	<!-- //USED FOR UPDATE DEVICES with btn -->
	{#if $showNewLayout}
		<div class="d-flex gap-s align-items-center">
			<Checkbox
				aria-label={$format('checkbox_select_device', {
					default: 'Checkbox select device',
				})}
				on:click={onHandleFilterSelect}
				disabled={typeof $updating_devices[device.id] !== 'undefined' ||
					isUpdating ||
					(device.shared &&
						$update.type !== 'bulk_move_devices_to_another_room' &&
						$update.type !== 'bulk_delete') || // disable checkbox if device is shared and not in transfer or delete mode
					($update.type === 'account_transfer_devices' && device.shared_by_me) ||
					(disableSelection && !Object.keys($update.selectedDevices).includes(device.id))}
				checked={!!$update.selectedDevices[device.id]}
				id="checkbox-mihrry0"
			/>
			<!-- !Object.keys($update.selectedDevices).includes(device.id) -->
			<!-- disable not selected devices to not select any other devices -->
			{#if $update.type === 'update'}
				<IconButton
					aria-label={$format('button_update_device', {
						default: 'Button update device',
					})}
					icon="fas fa-arrows-rotate"
					disabled={typeof $updating_devices[device.id] !== 'undefined' || isUpdating}
					on:click={onHandleDeviceUpdate}
				/>
			{/if}
		</div>
	{:else}
		<ActionsContainer hideSlotSecond={$update.type !== 'update'}>
			<Checkbox
				aria-label={$format('checkbox_select_device', {
					default: 'Checkbox select device',
				})}
				slot="first"
				on:click={onHandleFilterSelect}
				disabled={typeof $updating_devices[device.id] !== 'undefined' ||
					isUpdating ||
					(device.shared &&
						$update.type !== 'bulk_move_devices_to_another_room' &&
						$update.type !== 'bulk_delete') || // disable checkbox if device is shared and not in transfer or delete mode
					($update.type === 'account_transfer_devices' && device.shared_by_me) ||
					(disableSelection && !Object.keys($update.selectedDevices).includes(device.id))}
				checked={!!$update.selectedDevices[device.id]}
				id="checkbox-mihrry0"
			/>
			<!-- !Object.keys($update.selectedDevices).includes(device.id) -->
			<!-- disable not selected devices to not select any other devices -->
			<IconButton
				aria-label={$format('button_update_device', {
					default: 'Button update device',
				})}
				icon="fas fa-arrows-rotate"
				slot="second"
				disabled={typeof $updating_devices[device.id] !== 'undefined' || isUpdating}
				on:click={onHandleDeviceUpdate}
			/>
		</ActionsContainer>
	{/if}
{:else if is_gen_2(device) && isLoading && isUpdating}
	{#if isWallDisplay(device?.type) && fwUpdateProgress >= 99}
		<Loader size="m" class="align-self-center" />
	{:else}
		<CircularProgress
			size={'s'}
			backgroundColor={$showNewLayout ? '--color-2' : '--color-1'}
			progress={fwUpdateProgress}
			type={fwUpdateProgress > 100 ? 'success' : 'primary'}
		/>
	{/if}
{:else if isLoading}
	<Loader size="m" class="align-self-center" />
{:else if notAuthenticated && isLoading}
	<IconButton
		aria-label={$format('button_authenticate_device', {
			default: 'Button authenticate device',
		})}
		size="l"
		{icon}
		class={`text-${iconColor} mt-m mb-m mr-s`}
		on:click={(e) => {
			e.stopPropagation();
			authenticate = true;
		}}
	/>
{:else if device?.mainActionType === 'param' && mainParamElement?.n !== 'click combinations' && !inPreivew}
	<!-- //CTRITICAL EVENT -->
	{@const hasCriticalEvent = checkIsCriticalEvent(mainParamElement?.value)}
	{#if useV2Components}
		<LabelV2
			size={labelSizeCondition}
			icon={mapIconSolidWeightToLight(mainParamElement?.icon)}
			iconStyle={mainParamElement?.iconStyle}
			value={mainParamElement?.value}
			class="align-self-center max-width-full"
			iconColor={mainParamElement?.iconColor}
			isVertical={isCondensed}
			{...labelV2Props}
			{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
			{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
			{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-base' } : {}}
		/>
	{:else}
		<Label
			size={labelSizeCondition}
			icon={mainParamElement?.icon}
			iconStyle={mainParamElement?.iconStyle}
			value={mainParamElement?.value}
			class="align-self-center max-width-full"
			iconColor={mainParamElement?.iconColor}
			{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
			{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
			{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-1' } : {}}
		/>
	{/if}
{:else if device?.mainActionType === 'param' && mainParamElement?.n === 'click combinations' && !inPreivew}
	<!-- // TODO Inputreader may not be shown in new dash card with controls ? -->

	<InputsReaderVisualizer
		deviceButtonV2Props={$showNewLayout ? devBtnsV2Props?.deviceButtonV2 : null}
		{useV2Components}
		showLabel
		{device}
		{status}
		{settings}
		isInCard={false}
		{labelV2Props}
	/>
	<!-- use new prop for btn size if new layout only, go pass it where not on dash widget, repeat for other places -- i think it should be ok like that -->
	<!-- size={$showNewLayout && !isOnDashWidget ? 'm' : 's'} -->
{:else if status?.online && !isLoading && isVirtualDevice(device?.type) && statuses}
	<!-- Check if the Virtual device is not disabled or not offline -->
	{#if $deviceState?.type > 0 && $deviceState?.type != 14}
		<VirtualDeviceControl {device} {statuses} labelProps={labelV2Props} {devBtnsV2Props} />
	{/if}
{:else if status?.online && !isLoading && isPeripheralDevice(device?.type) && statuses}
	<!-- Check if the Peripheral device is not disabled or not offline -->
	{#if $deviceState?.type > 0}
		{#if device.category == 'relay'}
			<!-- TODO: Should we pass size here ? -->
			<ControlOnOffAddon
				{device}
				{status}
				component={device.component}
				class="align-self-center"
				{useV2Components}
			/>
		{:else}
			{@const mainLabel = statuses?.find((i) => i?.mainLabel)}
			{#if mainLabel}
				{#if useV2Components}
					<LabelV2
						class="align-self-center max-width-full"
						icon={mapIconSolidWeightToLight(mainLabel?.icon) || null}
						iconColor={mainLabel?.iconColor || null}
						value={mainLabel.value || ''}
						size={'l'}
						isVertical={isCondensed}
						{...labelV2Props}
					/>
				{:else}
					<Label
						class="align-self-center max-width-full"
						icon={mainLabel?.icon || null}
						iconColor={mainLabel?.iconColor || null}
						value={mainLabel.value || ''}
						size={'m'}
					/>
				{/if}
			{/if}
		{/if}
	{/if}
{:else if status?.online && !isLoading && isXT1Module(device?.type) && statuses}
	<TemplatesControl {useV2Components} {device} {statuses} {labelV2Props} {devBtnsV2Props} />
{:else if status?.online && !isLoading && device?.type === 'S4SN-0U61X' && isGen2}
	<RadarControl {useV2Components} {labelV2Props} {status} />
{:else if $deviceState?.type > 0 && $deviceState?.type < 99 && !checkDeviceForceUpdate(device)}
	<Icon {icon} class={`text-${iconColor} align-self-center`} />
{:else if status?.online && !isLoading && isBluTRV(device.type)}
	<BluTrvControl {useV2Components} {device} {statuses} {devBtnsV2Props} />
{:else if status?.online && !isLoading && isPill(device.type)}
	<PillControlStatusSlot
		{useV2Components}
		{device}
		{statuses}
		{status}
		{type}
		{labelV2Props}
		deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
	/>
{:else if status?.online && !isLoading && (device.category === 'sensor' || device.category === 'gateway' || isIRControllerCategory(device))}
	{@const hasCriticalEvent = checkIsCriticalEvent(main_label?.value)}
	{#if useV2Components}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
			value={main_label.value || ''}
			size={labelSizeCondition}
			isVertical={isCondensed}
			iconColor={main_label.iconColor}
			{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
			{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
			{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-base' } : {}}
			{...labelV2Props}
		/>
	{:else}
		<Label
			class="align-self-center max-width-full"
			icon={main_label.icon || 'fas fa-sensor'}
			value={main_label.value || ''}
			type={'color-0'}
			size={labelSizeCondition}
			isVertical={isCondensed}
			iconColor={main_label.iconColor}
			{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
			{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
			{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-1' } : {}}
		/>
	{/if}
{:else if status?.online && !isLoading && isInputsReader}
	<!-- // TODO Inputreader may not be shown in new dash card with controls ? -->
	<InputsReaderVisualizer
		deviceButtonV2Props={$showNewLayout ? devBtnsV2Props?.deviceButtonV2 : null}
		{useV2Components}
		showLabel
		{device}
		{status}
		{settings}
		{labelV2Props}
	/>
{:else if status?.online && !isLoading && mode === 'roller'}
	{#if isGen2}
		<ControlDirectionG2 {devBtnsV2Props} {useV2Components} {device} {status} />
	{:else if isGenZ}
		<ControlDirectionZ
			{useV2Components}
			{devBtnsV2Props}
			{device}
			{status}
			class="align-self-center"
		/>
	{:else}
		<ControlDirection
			{useV2Components}
			{devBtnsV2Props}
			{device}
			{status}
			class="align-self-center"
		/>
	{/if}
{:else if status?.online && !isLoading && device.category === 'thermostat'}
	{#if !isWallDisplay(device.type)}
		<ControlTrv
			{devBtnsV2Props}
			{useV2Components}
			{device}
			{status}
			{settings}
			class="align-self-center"
		/>
	{:else}
		<ControlWallDisplayThermostat {useV2Components} {devBtnsV2Props} {device} />
	{/if}
{:else if status?.online && !isLoading && device.mode === 'media_player'}
	<ControlMedia {device} />
{:else if status?.online && !isLoading && ((device.category === 'power_meter' && isGen2) || isNoRelayPlug(device.type))}
	{#if useV2Components}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
			value={main_label.value || ''}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
			isVertical={isCondensed}
			{...labelV2Props}
		/>
	{:else}
		<Label
			class="align-self-center max-width-full"
			icon={main_label.icon || 'fas fa-sensor'}
			value={main_label.value || ''}
			type={'color-0'}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
		/>
	{/if}
{:else if status?.online && !isLoading && device.category === 'pv'}
	{#if useV2Components}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
			value={main_label.value || ''}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
			isVertical={isCondensed}
			{...labelV2Props}
		/>
	{:else}
		<Label
			class="align-self-center max-width-full"
			icon={main_label.icon || 'fas fa-sensor'}
			value={main_label.value || ''}
			type={'color-0'}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
		/>
	{/if}
{:else if status?.online && !isLoading && device.category === 'emeter' && isGen2}
	<!-- {#if isGen2} -->
	{@const peripheral = getAddonStatus(device, [], false, true)}
	{#if peripheral.find((i) => i.peripheralType == 'switch')}
		<ControlOnOffAddon
			{device}
			{status}
			component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor?.component}
			class="align-self-center"
			{useV2Components}
		/>
	{/if}
	<!-- ToDo: maybe display the calculated current consumption for 3 phases -->

	<!-- Adding this additional check isEMWithoutSwitch, because with the inclusion 
	  in Gen4 of EM devices without switch we have a situation, that requires to hide the Turn on/off
	  button, because we have nothing to toggle/turn  -->
	{#if isGen2EM(device.type) && !isEMWithoutSwitch(device.type)}
		<!-- Can we get this from prop -->
		<ControlOnOff
			useV2Components={$showNewLayout}
			{device}
			{status}
			{settings}
			deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
			class="align-self-center ml-xs"
		/>
	{/if}
	<!-- {/if} -->
{:else if status?.online && isCameraDevice(device)}
	<ControlCamera {device} {useV2Components} deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2} />
{:else if status?.online && settings && !isLoading}
	{#if isGenZ}
		<ControlOnOffZ
			{useV2Components}
			{device}
			{status}
			{settings}
			deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
			class="align-self-center"
		/>
	{:else if isLoqed}
		<ControlLock {devBtnsV2Props} {useV2Components} {device} />
	{:else if !isActuator}
		{#if device.category === 'module' && mode === 'shell'}
			<!-- Module in shell mode has no controls -->
		{:else if mode === 'cct' || (!noControlGearDevices && !daliErrors)}
			{#if !isDiffuser(device.type) && !isNoRelayPlug(device.type)}
				{#if isProSensorAddon(device)}
					{@const peripheral = getAddonStatus(device, [], false, true)}
					{#if peripheral.find((i) => i.peripheralType == 'switch')}
						<ControlOnOffAddon
							{device}
							{status}
							deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
							{useV2Components}
							component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor
								?.component}
							class="mr-xs align-self-center"
						/>
					{/if}
				{/if}
				{#if !(isFanDevice(device?.type) && status?.['fan:0']?.mode === 'auto')}
					<ControlOnOff
						useV2Components={$showNewLayout}
						deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
						{device}
						{status}
						{settings}
						class="align-self-center"
					/>
				{/if}
				{#if isFanDevice(device?.type) && status?.['fan:0']?.mode === 'auto'}
					<ControlVentoraBoost
						{device}
						{status}
						useV2Components={$showNewLayout}
						deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
						class="align-self-center ml-xs"
					/>
				{/if}
			{:else}
				<ControlOnOffDiffuser
					deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
					{useV2Components}
					{device}
					bind:status
				/>
			{/if}
		{:else}
			<Icon class="align-self-center" icon="fas fa-circle-x" />
		{/if}
	{:else if useV2Components}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
			value={main_label.value || ''}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
			isVertical={isCondensed}
			{...labelV2Props}
		/>
	{:else}
		<Label
			class="align-self-center max-width-full"
			icon={main_label.icon || 'fas fa-sensor'}
			value={main_label.value || ''}
			type={'color-0'}
			size={labelSizeCondition}
			iconColor={main_label.iconColor}
		/>
	{/if}
{/if}

{#if authenticate}
	<AuthenticateDevice {device} bind:showModal={authenticate} />
{/if}
